import { connectRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import { Reducer } from 'redux';
import modalsReducer from '../features/modals/modalsSlice';
import authReducer from '../features/auth/authSlice';
// eslint-disable-next-line import/no-cycle
import ordersReducer from '../features/orders/ordersSlice';
import offersReducer from '../features/offers/offersSlice';

export const history = createBrowserHistory();

export const rootReducer = {
  router: connectRouter(history) as Reducer,
  modals: modalsReducer,
  auth: authReducer,
  offers: offersReducer,
  orders: ordersReducer,
};
